export const isBrowser =
  typeof window !== 'undefined' && typeof window.document !== 'undefined';

export const injectStyle = (rule: string) => {
  const styleEl = document.createElement('style');
  document.head.appendChild(styleEl);
  const styleSheet = styleEl.sheet;
  styleSheet?.insertRule(rule, styleSheet.cssRules.length);
};
